import { AuthWrapper } from "@/lib/aws-amplify";

type MFASettingsType = {
	type: "EMAIL";
	mfaStatus: "ENABLED" | "DISABLED";
};

type UpdateMfaSettingsResultType = {
	success: boolean;
	type: "EMAIL";
	mfaStatus: "ENABLED" | "DISABLED";
};

export type { MFASettingsType, UpdateMfaSettingsResultType };

export const useMfaSettings = () => {
	const updateMfaSettings = async (
		mfaSettings: Pick<MFASettingsType, "mfaStatus">,
	): Promise<UpdateMfaSettingsResultType> => {
		try {
			await AuthWrapper.authUpdateEmailMFAPreference({
				email: mfaSettings.mfaStatus,
			});
		} catch (err) {
			return {
				success: false,
				type: "EMAIL",
				mfaStatus: mfaSettings.mfaStatus,
			};
		}

		return {
			success: true,
			type: "EMAIL",
			mfaStatus: mfaSettings.mfaStatus,
		};
	};

	const fetchMfaSettings = async (): Promise<MFASettingsType> => {
		const res = await AuthWrapper.authFetchMFAPreference();
		const enabledStatus = res.enabled?.includes("EMAIL") ? "ENABLED" : "DISABLED";

		return {
			type: "EMAIL",
			mfaStatus: enabledStatus,
		};
	};

	return {
		updateMfaSettings,
		fetchMfaSettings,
	};
};
